import { handleActions } from 'redux-actions';
import {
  LOGIN_USER_PENDING,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGOUT_USER
} from '../actions/user';


const defaultState = { data: JSON.parse(localStorage.getItem('user')), loading: false };

export default handleActions({
  [LOGIN_USER_PENDING]: (state, action) => {
    return {
      data: undefined,
      loading: true,
      cancelTokenSource: action.payload.cancelTokenSource
    };
  },
  [LOGIN_USER_SUCCESS]: (state, action) => {
    return {
      data: action.payload,
      loading: false,
      cancelTokenSource: null
    };
  },
  [LOGIN_USER_ERROR]: (state, action) => {
    return {
      data: undefined,
      loading: false,
      error: action.payload,
      cancelTokenSource: null
    };
  },
  [LOGOUT_USER]: (state, action) => {
    return {
      data: undefined,
      loading: false
    };
  }
}, defaultState)